// extracted by mini-css-extract-plugin
module.exports = {"switchWrp":"switch_switchWrp__15lGt","tab":"switch_tab__2EhB3","active":"switch_active__cCLLK"};